import { render, staticRenderFns } from "./DropSelect.vue?vue&type=template&id=072bba4d&scoped=true&"
import script from "./DropSelect.vue?vue&type=script&lang=js&"
export * from "./DropSelect.vue?vue&type=script&lang=js&"
import style0 from "./DropSelect.vue?vue&type=style&index=0&id=072bba4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072bba4d",
  null
  
)

export default component.exports